import * as React from 'react';
/**
 *
 * Original name: highlight
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1058
 *
 */
export const HighlightLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m18.022 6.662-.654-.667a3.308 3.308 0 0 0-4.736 0l-5.942 6.05V14.1a3.02 3.02 0 0 1-.868 2.133l-1.275 1.293 3.21 1.071.218-.22a2.886 2.886 0 0 1 2.072-.877h2.027l5.95-6.055a3.43 3.43 0 0 0-.002-4.783ZM11.446 16h-1.4a4.358 4.358 0 0 0-2.215.6l-.242-.246c.394-.687.6-1.466.6-2.258v-1.439l.332-.338 3.27 3.331-.346.35Zm1.396-1.421L9.573 11.25l3.27-3.328 3.268 3.328-3.269 3.329Zm4.3-4.421-3.227-3.286a1.854 1.854 0 0 1 2.383.174l.652.666a1.922 1.922 0 0 1 .192 2.446Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
